import { useForm } from "react-hook-form";

export default useForm;
